import React from 'react';
import Hex from '../../map/Hex.js';
import Single1 from './variant/Single1.js';
import { createListOfAllVariants, createVariantGroups, } from '../utils/withRotation.js';
import OneAdjacent1 from './variant/OneAdjacent1.js';
import TwoAdjacents1 from './variant/TwoAdjacents1.js';
import ThreeAdjacents1 from './variant/ThreeAdjacents1.js';
import FourAdjacents1 from './variant/FourAdjacents1.js';
import FiveAdjacents1 from './variant/FiveAdjacents.js';
import Ridge1 from './variant/Ridge1.js';
import Turn1 from './variant/Turn1.js';
import { TERRAIN_COLOR_PLAIN } from '../colors.js';
const basicVariants = {
    default: Single1,
    single1: Single1,
    oneAdjacent1: OneAdjacent1,
    twoAdjacents1: TwoAdjacents1,
    threeAdjacents1: ThreeAdjacents1,
    fourAdjacents1: FourAdjacents1,
    fiveAdjacents1: FiveAdjacents1,
    ridge1: Ridge1,
    turn1: Turn1,
};
export const variantGroups = createVariantGroups(Object.keys(basicVariants));
const variants = createListOfAllVariants(basicVariants);
function HillHex({ style = {}, children, ...props }) {
    let variantName = props.graphicalVariant ?? 'default';
    if (variants[variantName] === undefined) {
        variantName = 'default';
    }
    const Variant = variants[variantName];
    if (variantName === 'default') {
        return (React.createElement(Hex, { ...props, style: {
                ...style,
                fill: '#996633',
            } }, children));
    }
    return (React.createElement(Hex, { ...props, style: {
            ...style,
            fill: TERRAIN_COLOR_PLAIN,
        } },
        React.createElement(Variant, { ...props }),
        children));
}
export const graphicalVariants = Object.keys(variants);
export default HillHex;
